module.exports = __webpack_public_path__ + "img/home_view_pager_003.855c8a95.png";